import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga4';
import store from './marinetools/store.js';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';
import MarineMasterTrainingTopics from './pages/MarineMasterTrainingTopics.jsx';
import IalaBuoyageSystemRegionA from './pages/IalaBuoyageSystemRegionA.jsx';
import WeatherObservationCodes from './pages/WeatherObservationCodes.jsx';
import Tides from './pages/Tides.jsx';
import TidesStandardPorts from './pages/TidesStandardPorts.jsx';
import TidesSecondaryPorts from './pages/TidesSecondaryPorts.jsx';
import TidesUnderKeelClearance from './pages/TidesUnderKeelClearance.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';

// Compare against the string: CRA inlines env vars as strings, so the literal
// "false" is truthy and a plain !REACT_APP_GA4_DISABLED check disables GA4
// exactly when it is configured to be on.
if (process.env.REACT_APP_GA4_DISABLED !== 'true' && process.env.REACT_APP_GA4_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID);
}

export default function App() {
  return (
    <Provider store={store}>
      <Router>
        <Navbar />
        <main className="as-main">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/marine-master-training-topics" component={MarineMasterTrainingTopics} />
            <Route exact path="/iala-buoyage-system-region-a" component={IalaBuoyageSystemRegionA} />
            <Route exact path="/weather-observation-codes" component={WeatherObservationCodes} />
            <Route exact path="/tides" component={Tides} />
            <Route exact path="/tides-standard-ports" component={TidesStandardPorts} />
            <Route exact path="/tides-secondary-ports" component={TidesSecondaryPorts} />
            <Route exact path="/tides-under-keel-clearance" component={TidesUnderKeelClearance} />
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          </Switch>
        </main>
        <Footer />
      </Router>
    </Provider>
  );
}
